import { useState } from 'react';
import { trpc } from '@/shared/api';
import { useLandingPartnerUpload } from './use-landing-partner-upload';

interface UseReplaceLandingPartnerImageOptions {
  readonly onSuccess?: () => void;
}

/** 같은 항목의 로고 파일만 새 파일로 바꾼다. 기업명·순서는 그대로다. */
export const useReplaceLandingPartnerImage = ({
  onSuccess,
}: UseReplaceLandingPartnerImageOptions = {}) => {
  const uploader = useLandingPartnerUpload();
  const [pendingId, setPendingId] = useState<string | null>(null);
  const mutation = trpc.landing.replacePartnerImage.useMutation({
    onSuccess,
    onSettled: () => setPendingId(null),
  });

  const replaceImage = async (id: string, file: File): Promise<void> => {
    setPendingId(id);
    const imageKey = await uploader.upload(file);

    if (imageKey === null) {
      setPendingId(null);
      return;
    }

    mutation.mutate({ id, imageKey });
  };

  return {
    replaceImage,
    pendingId,
    error: uploader.error ?? mutation.error?.message ?? null,
    /** 지난 업로드·서버 오류를 지운다 — 관리 화면의 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: () => {
      mutation.reset();
      uploader.clearError();
    },
  };
};
